/**
 * Shared formatting utilities.
 *
 * Centralises date/time helpers that were previously duplicated across
 * ChatMessage.js (formatTimestamp) and DocumentsPanel.js (formatDate).
 */

/**
 * Format an ISO timestamp as "YYYY.MM.DD HH:mm".
 * Used for message bubble timestamps.
 */
export function formatTimestamp(iso) {
  if (!iso) return '';
  const d   = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Format an ISO timestamp as "YYYY.MM.DD".
 * Used for document upload dates in the sidebar.
 */
export function formatDate(iso) {
  if (!iso) return '';
  const d   = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}.${pad(d.getMonth() + 1)}.${pad(d.getDate())}`;
}
